import { useQuery } from '@tanstack/react-query'

import { fetchTopics } from '../../topics/api/topicsClient'

export function useTagKeywordMap() {
  return useQuery({
    queryKey: ['topic-keyword-map'],
    queryFn: async ({ signal }) => {
      const res = await fetchTopics({ limit: 500 }, signal)
      const map = new Map<string, string[]>()
      for (const t of res.data) {
        if (t.keywords.length > 0) {
          map.set(
            t.name,
            t.keywords.map((k) => k.toLowerCase()),
          )
        }
      }
      return map
    },
    staleTime: 5 * 60_000,
  })
}
